import {
    FETCH_ALL_INTERPS,
    FETCH_SHARED_INTERPS,
    FETCH_R3D_INTERPS,
    CLEAR_R3D_INTERPS,
} from '../../actionTypes/shared/apiActionTypes';
import { MEASURE } from '../../../constants/shared/MeasuresConstants';
import {
    parseDyslexiaInterps,
    parseOlInterps,
    parseR3DInterps,
    parseVocaboInterps,
} from './interpReducerParsers';
import {
    getDyslexiaInterpBoundaries,
    getInterpsDataExcludingR3D,
} from '../../../utils/shared/interpReducerHelpers';

const { SPELLING, TRC } = MEASURE;

export const initialState = {
    data: [],
    isR3DInterpsFetched: false,
    isAllInterpsFetched: false,
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case FETCH_SHARED_INTERPS.VOCABO:
            return {
                ...state,
                data: [...state.data, ...parseVocaboInterps(action.response)],
            };
        case FETCH_SHARED_INTERPS.SPELLING:
            return {
                ...state,
                data: [
                    ...state.data,
                    ...parseDyslexiaInterps(action.response, SPELLING, getDyslexiaInterpBoundaries),
                ],
            };
        case FETCH_SHARED_INTERPS.OL:
            return {
                ...state,
                data: [...state.data, ...parseOlInterps(action.response)],
            };
        case FETCH_ALL_INTERPS.SUCCESS:
            return {
                ...state,
                isAllInterpsFetched: true,
            };
        case FETCH_SHARED_INTERPS.R3D:
            return {
                ...state,
                isR3DInterpsFetched: true,
            };
        case FETCH_ALL_INTERPS.ERROR:
            return {
                ...state,
                error: action.error,
            };
        case FETCH_R3D_INTERPS.SUCCESS:
            return {
                ...state,
                data: [...state.data, ...parseR3DInterps(action.response)],
                isR3DInterpsFetched: true,
            };
        case CLEAR_R3D_INTERPS:
            return {
                ...state,
                data: getInterpsDataExcludingR3D(state.data, TRC),
                isR3DInterpsFetched: false,
            };
        default:
            return state;
    }
};

const isInterpDataFetched = state => state.isAllInterpsFetched && state.isR3DInterpsFetched;

const getInterps = state => state.data;

export const selectors = {
    getInterps,
    isInterpDataFetched,
};
